import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PropTypes from 'prop-types';

const AAFModalResendEmail = (props = {}) => {
  const title = Translator.get('resendLink_modal_title_label','Está en camino un link para ti');
  const content = Translator.get('resendLink_modal_description_label','Este podría tardar hasta 10 minutos en llegar');
  const p = {
    content,
    title,
    alwaysEnabled: true,
    buttonsAlign: 'vertical',
    buttons: [
      {
        content: Translator.get('resendLink_modal_option_button_getNewPassword', 'Obtener nueva contraseña'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);}
        }
      },
      {
        content: Translator.get('resendLink_modal_option_button_close', 'Cerrar'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);},
          variant: 'dark'
        }
      }
    ],
    aafNewStyle: true,
    className: 'aaf-modal-resend-mail',
  };
  return <ModalWrapper {...p} />;
};

AAFModalResendEmail.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};

export default withOnClose(AAFModalResendEmail);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalResendEmail.jsx